import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Media} from 'kpc';

var _$tmp0 = {
    'name': '图片加载中.png',
    'type': 'image',
    'status': 'loading',
    'src': 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=320&q=80'
};
var _$tmp1 = {
    'name': '视频加载中.mp4',
    'type': 'video',
    'status': 'loading'
};
var _$tmp2 = {
    'name': '音频加载中.mp3',
    'type': 'audio',
    'status': 'loading'
};
var _$tmp3 = {
    'name': '图片加载失败.png',
    'type': 'image',
    'status': 'error',
    'src': 'https://example.com/broken.png'
};
var _$tmp4 = {
    'name': '视频加载失败.mp4',
    'type': 'video',
    'status': 'error',
    'src': 'https://example.com/broken.mp4'
};
var _$tmp5 = {
    'name': '音频加载失败.mp3',
    'type': 'audio',
    'status': 'error',
    'src': 'https://example.com/broken.mp3'
};
var _$tmp6 = {
    'name': '参考图.png',
    'type': 'image',
    'status': 'done',
    'src': 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=320&q=80'
};
var _$tmp7 = {
    'name': '产品预告.mp4',
    'type': 'video',
    'status': 'done',
    'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
    'poster': 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=320&q=80'
};
var _$tmp8 = {
    'name': '播客片段.mp3',
    'type': 'audio',
    'status': 'done',
    'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$ce(2, 'div', '加载中', 16, 'media-demo-status-label'),
            _$ce(2, 'div', [
                _$cc(Media, _$tmp0),
                _$cc(Media, _$tmp1),
                _$cc(Media, _$tmp2)
            ], 4, 'media-demo-status-row')
        ], 4, 'media-demo-status-section'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '加载失败', 16, 'media-demo-status-label'),
            _$ce(2, 'div', [
                _$cc(Media, _$tmp3),
                _$cc(Media, _$tmp4),
                _$cc(Media, _$tmp5)
            ], 4, 'media-demo-status-row')
        ], 4, 'media-demo-status-section'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '已完成', 16, 'media-demo-status-label'),
            _$ce(2, 'div', [
                _$cc(Media, _$tmp6),
                _$cc(Media, _$tmp7),
                _$cc(Media, _$tmp8)
            ], 4, 'media-demo-status-row')
        ], 4, 'media-demo-status-section')
    ], 4, 'media-demo-status');
};